<template>
  <div class="my-auto">
    <router-link tag="button"
                 :to="'abstract/' + abstract.id + '/confirm/'"
                 class="btn btn-link mx-auto text-danger"
                 v-if="abstract.confirmed === false && abstract.status_id === 3 && (submissions.isConfirmationOpen === true || submission_id === 2)">
      <icon :icon="['fad', 'calendar-exclamation']" class="fa-2x"/>
      <br>
      Confirm
    </router-link>
    <router-link tag="button"
                 :to="'abstract/' + abstract.id + '/confirm/'"
                 class="btn btn-link mx-auto text-success"
                 v-else-if="abstract.confirmed === true && abstract.status_id === 3 && (submissions.isConfirmationOpen === true || submission_id === 2)">
      <icon :icon="['fad', 'calendar-check']" class="fa-2x"/>
      <br>
      Confirmed
    </router-link>
    <button class="btn btn-link disabled mx-auto"
            v-else-if="abstract.confirmed === false && submissions.isConfirmationOpen === false && submission_id !== 2">
      <icon :icon="['fad', 'calendar-exclamation']" class="fa-2x"/>
      <br>
      Confirm
    </button>
    <button class="btn btn-link disabled mx-auto"
            v-else-if="abstract.confirmed === true && submissions.isConfirmationOpen === false && submission_id !== 2">
      <icon :icon="['fad', 'calendar-check']" class="fa-2x"/>
      <br>
      Confirmed
    </button>
    <button class="btn text-success pointer-no mx-auto"
            v-else-if="abstract.confirmed === true && submissions.isConfirmationOpen === true && submission_id !== 2">
      <icon :icon="['fad', 'calendar-check']" class="fa-2x"/>
      <br>
      Confirmed
    </button>
  </div>
</template>
<script>
  export default {
    name: 'TableConfirmArea',
    props: {
      abstract: {},
      submission_id: {},
      submissions: {}
    }
  }
</script>
<style scoped>
  @media (min-width: 10em) {
  }
</style>
